(() => {
  document.querySelectorAll('[data-references-section]').forEach((root) => {
    const grid = root.querySelector('[data-brand-grid]');
    const cards = grid ? Array.from(grid.querySelectorAll('.brand-card')) : [];
    const buttons = Array.from(root.querySelectorAll('[data-filter]'));
    const search = root.querySelector('[data-brand-search]');
    const resultCount = root.querySelector('[data-result-count]');
    const emptyState = root.querySelector('[data-empty-state]');
    if (!grid || !search || !resultCount || !emptyState || !cards.length) return;

    const normalize = (value) => value.toLocaleLowerCase('tr-TR').normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    const params = new URLSearchParams(window.location.search);
    let activeFilter = params.get('kategori') || 'all';
    let searchValue = params.get('q') || '';
    if (!buttons.some((button) => button.dataset.filter === activeFilter)) activeFilter = 'all';
    search.value = searchValue;

    const syncUrl = (mode = 'replace') => {
      const next = new URL(window.location.href);
      activeFilter === 'all' ? next.searchParams.delete('kategori') : next.searchParams.set('kategori', activeFilter);
      searchValue ? next.searchParams.set('q', searchValue) : next.searchParams.delete('q');
      window.history[mode === 'push' ? 'pushState' : 'replaceState']({ activeFilter, searchValue }, '', next);
    };

    const render = ({ historyMode = 'replace', updateUrl = true } = {}) => {
      const query = normalize(searchValue.trim());
      let visibleCount = 0;
      buttons.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.filter === activeFilter)));
      cards.forEach((card) => {
        const visible = (activeFilter === 'all' || card.dataset.category === activeFilter) && (!query || normalize(card.dataset.brand || '').includes(query));
        card.hidden = !visible;
        if (visible) visibleCount += 1;
      });
      resultCount.textContent = (resultCount.dataset.resultTemplate || '__COUNT__').replace('__COUNT__', String(visibleCount));
      emptyState.hidden = visibleCount !== 0;
      grid.hidden = visibleCount === 0;
      if (updateUrl) syncUrl(historyMode);
    };

    buttons.forEach((button) => button.addEventListener('click', () => { activeFilter = button.dataset.filter; render({ historyMode: 'push' }); }));
    search.addEventListener('input', () => { searchValue = search.value; render(); });
    window.addEventListener('popstate', () => {
      const next = new URLSearchParams(window.location.search);
      activeFilter = next.get('kategori') || 'all'; searchValue = next.get('q') || ''; search.value = searchValue; render({ updateUrl: false });
    });
    render({ updateUrl: false });
  });
})();
